import type { OutgoingMessage } from "@box/sdk-internal";

export interface IpcMessage {
  type: "box-ipc-message";
  message: SerializedOutgoingMessage;
}

export interface SerializedOutgoingMessage extends Omit<
  OutgoingMessage,
  typeof Symbol.dispose | "free" | "payload"
> {
  payload: number[];
}

export function isIpcMessage(message: any): message is IpcMessage {
  return message.type === "box-ipc-message";
}
